<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Student Schedule - Staff View</span>
            </div>
            <div style="display: flex; flex: 1; flex-direction: row;">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
                    <button mat-stroked-button class="mat-card-button" (click)="goToStudentSchedule()"><span translate>Go To Student Schedule</span>
                    </button>
                </div>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="flex: 1;display: flex;padding: 10px;">
                <div style="flex: 1;display: flex;justify-content: flex-start;">
                    <!-- Content Options -->
                    <tyl-form-field label="Term" style="align-self: flex-start">
                        <mat-select id="contentOptionsSelect" [(ngModel)]="selectedTermId" (selectionChange)="termChange()">                           
                            <mat-option *ngFor="let term of termOptions" [value]="term.Id">
                                {{term.CodeDescription}}
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </div>
                <div style="flex: 1;display: flex;justify-content: flex-end;">
                    <tyl-checkbox [(checked)]='showDropped' (change)="hideShowDropped();">Include dropped classes</tyl-checkbox>
                </div>
            </div>
            <mat-table style="width: 100%;" [dataSource]="studentSchedule">
                <!-- Meets Column -->
                <ng-container matColumnDef="Meets">
                    <mat-header-cell *matHeaderCellDef>Meets</mat-header-cell>
                    <mat-cell *matCellDef="let sr">{{sr.Meets}}</mat-cell>
                </ng-container>

                <!-- Term Column -->
                <ng-container matColumnDef="Term">
                    <mat-header-cell *matHeaderCellDef>Term</mat-header-cell>
                    <mat-cell *matCellDef="let sr">{{sr.Term}}</mat-cell>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="CourseName">
                    <mat-header-cell style="flex: 5" *matHeaderCellDef>Name</mat-header-cell>
                    <mat-cell style="flex: 5" *matCellDef="let sr">{{sr.Course}}</mat-cell>
                </ng-container>

                <!-- Course Section Column -->
                <ng-container matColumnDef="CourseSection">
                    <mat-header-cell style="flex: 3" *matHeaderCellDef>Course-Section</mat-header-cell>
                    <mat-cell style="flex: 3" *matCellDef="let sr">{{sr.SubjectCode}}-{{sr.Section}}</mat-cell>
                </ng-container>

                <!-- Entry Column -->
                <ng-container matColumnDef="EntryDate">
                    <mat-header-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matHeaderCellDef>
                        <span *ngIf="showDropped">Entry</span>
                    </mat-header-cell>
                    <mat-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matCellDef="let sr">
                        <span *ngIf="showDropped">{{sr.EntryDate | date:'MM/dd/yyyy'}}</span>
                    </mat-cell>
                </ng-container>

                <!-- Dropped Column -->
                <ng-container matColumnDef="DroppedDate">
                    <mat-header-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matHeaderCellDef>
                        <span *ngIf="showDropped">Dropped</span>
                    </mat-header-cell>
                    <mat-cell [ngClass]="{'show-dropped' : showDropped, 'hide-dropped': !showDropped}" *matCellDef="let sr">
                        <span *ngIf="showDropped && sr.DroppedDate != '0001-01-01T00:00:00'">{{sr.DroppedDate | date:'MM/dd/yyyy'}}</span>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row [ngClass]="{'dropped-course': row.dropped}" style="align-items: flex-start;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </div>
</mat-card>
